module.exports = __webpack_public_path__ + "static/media/71_zinc_metal_seamless.2b8b098a.jpg";